'use client';

import classNames from '@sindresorhus/class-names';
import Link from 'next/link';

import {MainLanding} from '@strapi/types';

import {useLocale} from '@utils/hooks/useLocale';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import styles from './SEOTags.module.scss';

type Props = {
  variant: 'colored' | 'default';
} & Pick<MainLanding, 'SEOTags'>;

export const SEOTags = ({variant, SEOTags}: Props) => {
  const locale = useLocale();

  if (!SEOTags?.links?.length) return null;
  const {links, title} = SEOTags;

  const onTagClick = (categoryName: string) => {
    return logTmrEvent('landing.thematicsBubble.click', {
      compilation_name: title,
      category_name: categoryName,
    });
  };

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.wrapper__transparent]: variant === 'colored',
      })}
    >
      <h2
        className={classNames(styles.title, {
          [styles.title__zh]: locale === 'zh',
        })}
      >
        {title}
      </h2>
      <div className={styles.overflow}>
        <div className={styles.chipsWrapper}>
          {links.map((item) => (
            <Link
              className={styles.chip}
              prefetch={false}
              href={item.href}
              key={item.title}
              onClick={() => onTagClick(item.title)}
            >
              {item.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
